import CommonIFrame from '../atoms/CommonIFrame';

const CommercialPolicySimulator = () => {
    return (
        <CommonIFrame
            src="https://commercial-policy-simulator.lovable.app/"
            title="Commercial Policy Simulator"
        />
    );
};

export default CommercialPolicySimulator;
